import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  getRouteKeyFromPath,
  localizedRoutes,
  stripLanguageFromPath,
} from "@/lib/i18nRoutes";

const DYNAMIC_BASE_BY_ROUTE_KEY = {
  learningCenter: "learning-center",
  learn: "learning-center",
  marinas: "marinas",
  weather: "weather",
  marineWeather: "marine-weather",
  routes: "routes",
  regulations: "regulations",
  glossary: "glossary",
  wire: "wire",
  tools: "sailing-calculators",
  destinations: "destinations",
};

function cleanInputPath(path = "/") {
  const raw = String(path || "/").split(/[?#]/)[0] || "/";
  const decoded = decodeURI(raw);
  return decoded === "/" ? "/" : `/${decoded.replace(/^\/+|\/+$/g, "")}`;
}

function routeKeyForSegment(segment) {
  if (!segment) return "home";
  return getRouteKeyFromPath(`/${segment}`);
}

export function normalizeSeoPath(path = "/") {
  const pathname = cleanInputPath(path);
  const parts = pathname.split("/").filter(Boolean);
  const pathLang = SUPPORTED_LANGUAGES.includes(parts[0]) ? parts.shift() : DEFAULT_LANGUAGE;

  if (parts.length === 0) {
    return { path: "/", routeKey: "home", lang: pathLang, isDynamic: false };
  }

  const firstRouteKey = routeKeyForSegment(parts[0]);
  const dynamicBase = DYNAMIC_BASE_BY_ROUTE_KEY[firstRouteKey];
  if (dynamicBase && parts.length > 1) {
    return {
      path: `/${dynamicBase}/${parts.slice(1).join("/")}`,
      routeKey: firstRouteKey,
      lang: pathLang,
      isDynamic: true,
    };
  }

  const fullRouteKey = getRouteKeyFromPath(pathname);
  if (fullRouteKey && localizedRoutes[fullRouteKey]?.[DEFAULT_LANGUAGE] != null) {
    const baseSlug = localizedRoutes[fullRouteKey][DEFAULT_LANGUAGE];
    return {
      path: baseSlug ? `/${baseSlug}` : "/",
      routeKey: fullRouteKey,
      lang: pathLang,
      isDynamic: false,
    };
  }

  return {
    path: stripLanguageFromPath(pathname) || "/",
    routeKey: fullRouteKey || firstRouteKey,
    lang: pathLang,
    isDynamic: false,
  };
}